var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31326 39.1194C2.98256 35.1387 1 30.0862 1 24.5745C1 11.8669 11.5472 1.60889 24.7907 1.60889C37.8756 1.60889 48.5814 11.8669 48.5814 24.5745C48.5814 30.0862 46.4403 35.1387 43.0303 39.1194M24.7907 1.76199V8.95788V1.76199ZM12.2609 5.20683L16.0675 11.4841L12.2609 5.20683ZM37.1619 5.20683L33.3554 11.4841L37.1619 5.20683ZM3.93419 13.7807L10.437 17.3786L3.93419 13.7807ZM45.33 13.7807L38.9858 17.3786L45.33 13.7807ZM1.1586 25.8759H8.69233H1.1586ZM40.7305 25.8759H48.3435H40.7305Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0714 43.4063H38.2721C39.3823 43.4063 40.2546 42.6408 40.2546 41.6456V38.507C40.2546 37.5118 39.4616 36.7463 38.3514 36.7463H11.1507C10.1198 36.7463 9.24744 37.5118 9.24744 38.507V41.5691C9.24744 42.6408 10.0405 43.4063 11.1507 43.4063H11.0714ZM14.0849 36.9759V43.1001V36.9759ZM35.3379 36.9759V43.1001V36.9759ZM30.0246 36.9759V43.1001V36.9759ZM24.7907 36.9759V43.1001V36.9759ZM19.2395 36.9759V43.1001V36.9759ZM28.2007 27.7896L37.717 12.9385L22.253 22.1248C19.5567 23.6558 20.0326 26.7179 21.8565 28.2489C23.4425 29.9331 26.6146 30.3159 28.2007 27.7896ZM23.4425 26.7179C24.077 27.4834 25.2665 27.4834 25.9802 26.7179C26.7732 25.9524 26.7732 24.8806 25.9802 24.1917C25.1872 23.5027 24.077 23.4261 23.3632 24.1917C22.6495 24.9572 22.5702 26.0289 23.3632 26.7179H23.4425Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.1e4e3f019597b2ab09abc20843863fc4.svg";
export { ForwardRef as ReactComponent };